export default {
  LOAD_STUDY_PROGRAM_SKILL_ABILITY_LIST_START: 'LoadStudyProgramSkillAbilityListStart',
  LOAD_STUDY_PROGRAM_SKILL_ABILITY_LIST_END: 'LoadStudyProgramSkillAbilityListEnd',
  TOGGLE_STUDY_PROGRAM_SKILL_ABILITY_LIST_CONFIRM_DIALOG: 'ToggleStudyProgramSkillAbilityListConfirmDialog'
};